import store from '@/store';

export default [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue'),
    meta: {
      title: 'صفحه اصلی'
    }
  },
  {
    path: '/access-denied',
    name: 'AccessDenied',
    component: () => import('../views/account/AccessDenied.vue'),
    meta: {
      title: 'دسترسی غیر مجاز'
    }
  },
  {
    path: '/account/login',
    name: 'Login',
    component: () => import('../views/account/Login.vue'),
    meta: {
      title: 'ورود'
    },
    beforeEnter: (to: any, from: any, next: any) => {
      if (store.getters.isLoggedIn) {
        next('/');
      }
      next();
    }
  },
  {
    path: '/account/forgot-password',
    name: 'ForgotPassword',
    component: () => import('../views/account/ForgotPassword.vue'),
    meta: {
      title: 'بازیابی رمز عبور'
    }
  },
  {
    path: '/invoice/manage',
    name: 'Invoice',
    component: () => import('@/views/invoice/Invoice.vue'),
    meta: {
      title: 'صورت حساب',
      requiredAuth: true
    }
  },
  {
    path: '/invoice/detail/:id',
    name: 'InvoiceDetail',
    component: () => import('../views/invoice/InvoiceDetail.vue'),
    meta: {
      title: 'فاکتور فروش',
      requiredAuth: true
    }
  },
  {
    path: '/wallet/payment-call-back',
    name: 'CallBack',
    component: () => import('../views/wallet/PaymentCallBack.vue'),
    meta: {
      title: 'نتیجه پرداخت',
      requiredAuth: true
    }
  },
  {
    path: '/wallet/wallet-transaction/:id',
    name: 'WalletTransaction',
    component: () => import('@/views/wallet/WalletTransaction.vue'),
    meta: {
      title: 'تراکنش کیف پول',
      requiredAuth: true
    }
  },
  {
    path: '/wallet/wallet-deposit',
    name: 'WalletDeposit',
    component: () => import('@/views/wallet/WalletDeposit.vue'),
    meta: {
      title: 'واریز وجه',
      requiredAuth: true
    }
  },
  {
    path: '/wallet/wallet-payment',
    name: 'WalletPayment',
    component: () => import('@/views/wallet/WalletPayment.vue'),
    meta: {
      title: 'گزارش واریز وجه',
      requiredAuth: true
    }
  },
  {
    path: '/portal/change-password',
    name: 'ChangePassword',
    component: () => import('../views/profile/ChangePassword.vue'),
    meta: {
      title: 'تغییر رمز عبور',
      requiredAuth: true
    }
  },
  {
    path: '/support/manage',
    name: 'Support',
    component: () => import('../views/support/Support.vue'),
    meta: {
      title: 'پشتیبانی',
      requiredAuth: true
    }
  },
  {
    path: '/portal/support-subject',
    name: 'SupportSubject',
    component: () => import('../views/support/SupportSubject.vue'),
    meta: {
      title: 'موضوعات پشتیبانی',
      requiredAuth: true
    }
  },
  {
    path: '/portal/notification',
    name: 'Notification',
    component: () => import('../views/portal/Notification.vue'),
    meta: {
      title: 'اطلاع رسانی ها',
      requiredAuth: true
    }
  },
  {
    path: '/portal/notification-setting',
    name: 'NotificationSetting',
    component: () => import('../views/profile/NotificationSetting.vue'),
    meta: {
      title: 'تنظسمات اطلاع رسانی',
      requiredAuth: true
    }
  },
  {
    path: '/portal/profile',
    name: 'Profile',
    component: () => import('../views/profile/Profile.vue'),
    meta: {
      title: 'حساب کاربری',
      requiredAuth: true
    }
  },
  {
    path: '/user/manage',
    name: 'User',
    component: () => import('../views/user/Users.vue'),
    meta: {
      title: 'مدیریت کاربران',
      requiredAuth: true
    }
  },
  {
    path: '/company/manage',
    name: 'Company',
    component: () => import('../views/company/Company.vue'),
    meta: {
      title: 'مدیریت شرکتها',
      requiredAuth: true
    }
  },
  {
    path: '/group/manage',
    name: 'Group',
    component: () => import('../views/group/Group.vue'),
    meta: {
      title: 'مدیریت گروه ها',
      requiredAuth: true
    }
  },
  {
    path: '/group/item/:id',
    name: 'GroupDetail',
    component: () => import('@/views/group/GroupDetail.vue'),
    meta: {
      title: 'تنظیمات گروه',
      requiredAuth: true
    }
  },
  {
    path: '/group/runs',
    name: 'GroupRuns',
    component: () => import('@/views/group/GroupRuns.vue')
  },
  {
    path: '/group/wallet/:id',
    name: 'GroupWallet',
    component: () => import('@/views/group/GroupWallet.vue'),
    meta: {
      title: 'تراکنش کیف پول',
      requiredAuth: true
    }
  },
  {
    path: '/sim/manage',
    name: 'Sim',
    component: () => import('../views/sim/Sim.vue'),
    meta: {
      title: 'مدیریت سیم کارت ها',
      requiredAuth: true
    }
  },
  {
    path: '/report',
    name: 'Report',
    component: () => import('../views/report/Report.vue'),
    meta: {
      title: 'گزارشات',
      requiredAuth: true
    }
  },
  {
    path: '*',
    name: 'NotFound',
    component: () => import('../views/NotFound.vue'),
    meta: {
      title: 'صفحه مورد نظر یافت نشد'
    }
  }
];
